export default __webpack_public_path__ + "static/media/arrow-right.cda9c481.svg";